export const boxes = ["Right", "Bottom", "Top", "Left"];
